import { createStaffImportsApi } from "@lafayette/api-client";

import { currentAccessToken } from "../catalog/admin-runtime";
import { getAdminPublicConfig } from "../config/public-config";
import type { ImportsRuntime } from "./runtime";

/**
 * The runtime of the real admin app: the typed client over `fetch` (it also does the direct upload to
 * storage) and the clock. The bearer token comes from the same function the catalog uses, so the
 * development token stays behind the one `import.meta.env.DEV` branch.
 */
export function createAdminImportsRuntime(): ImportsRuntime {
  const config = getAdminPublicConfig();
  return {
    api: createStaffImportsApi({
      baseUrl: config.apiUrl.toString(),
      getAccessToken: currentAccessToken,
    }),
    now: () => new Date(),
  };
}
